type NotifKindIconProps = {
  kind: string
  className?: string
}

/** Monochrome stroke icons — no emoji, no per-kind colors. */
export default function NotifKindIcon({ kind, className = '' }: NotifKindIconProps) {
  const cn = `vc-notif-svg${className ? ` ${className}` : ''}`
  const stroke = 'currentColor'
  const common = { fill: 'none', stroke, strokeWidth: 1.75, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const }

  if (kind === 'exchange_offer' || kind === 'exchange_send_to_warehouse' || kind === 'exchange_direct') {
    return (
      <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
        <path {...common} d="M7 7h13l-3-3M17 17H4l3 3" />
      </svg>
    )
  }
  if (kind === 'new_offer' || kind === 'offer_message') {
    return (
      <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
        <path {...common} d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" />
      </svg>
    )
  }
  if (kind === 'offer_accepted') {
    return (
      <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
        <path {...common} d="M20 6 9 17l-5-5" />
      </svg>
    )
  }
  if (kind === 'offer_rejected' || kind === 'offer_superseded') {
    return (
      <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
        <path {...common} d="M18 6 6 18M6 6l12 12" />
      </svg>
    )
  }
  if (kind === 'order_shipped' || kind === 'delivery_confirmed') {
    return (
      <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
        <path {...common} d="M3 7h11v8H3zM14 10h4l3 3v2h-7V10z" />
        <circle cx="7" cy="17" r="1.5" fill="currentColor" stroke="none" />
        <circle cx="17" cy="17" r="1.5" fill="currentColor" stroke="none" />
      </svg>
    )
  }
  if (kind === 'transaction_cancelled') {
    return (
      <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
        <path {...common} d="M12 9v4M12 17h.01" />
        <path {...common} d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      </svg>
    )
  }
  return (
    <svg className={cn} viewBox="0 0 24 24" width={22} height={22} aria-hidden="true">
      <path {...common} d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path {...common} d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  )
}
